function SectionFaqReturn() {
    return (
        <>
            <div className="tw-faq-section">
                <div className="accordion tw-faq" id="sf-faq-accordion-4">
                    {/*one*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ1-4" aria-expanded="false">
                            How long will it take to post my job?
                        </button>
                        <div id="FAQ1-4" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-4">
                            <div className="accordion-body">
                                The creation form is super easy to complete. Once finished, jobs go online instantly subject to moderation verification checks.
                            </div>
                        </div>
                    </div>
                    {/*two*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ2-4" aria-expanded="false">
                            What is your cancellation policy?
                        </button>
                        <div id="FAQ2-4" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-4">
                            <div className="accordion-body">
                                You can disable auto-renew or request package refunds within 14 days of activation if you have not successfully filled the position.
                            </div>
                        </div>
                    </div>
                    {/*three*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ3-4" aria-expanded="false">
                            Where Can I Find Market Research Reports?
                        </button>
                        <div id="FAQ3-4" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-4">
                            <div className="accordion-body">
                                General salary ranges and company growth stats can be viewed directly under the site stats content sheets in the employer dashboard.
                            </div>
                        </div>
                    </div>
                    {/*four*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ4-4" aria-expanded="false">
                            Do I need to know PHP to use TheJobs?
                        </button>
                        <div id="FAQ4-4" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-4">
                            <div className="accordion-body">
                                No coding is needed. Our platform offers a clear builder so anyone can set up listings easily.
                            </div>
                        </div>
                    </div>
                    {/*five*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ5-4" aria-expanded="false">
                            How soon will I start receiving resumes?
                        </button>
                        <div id="FAQ5-4" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-4">
                            <div className="accordion-body">
                                Candidates apply immediately, so resumes begin appearing in your applicants dashboard in real-time.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SectionFaqReturn;